<template>
  <div v-show="isDisplayed" class="overlay" @click="$emit('overlay-clicked')"></div>
</template>

<script>
export default {
  name: 'Overlay',
  props: {
    isDisplayed: {
      type: Boolean,
      default: true
    }
  }
}
</script>
